/**
 * ISO 형식 날짜 문자열을 YYYY.MM.DD 형식으로 변환합니다.
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    
    // 유효한 날짜인지 확인
    if (isNaN(date.getTime())) return '-';
    
    const year = date.getFullYear();
    // 월과 일은 두 자리로 표시 (01, 02, ...)
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}.${month}.${day}`;
  } catch (error) {
    console.error('날짜 형식 변환 오류:', error);
    return '-';
  }
}; 